<template>
  <div>
    <h2>个人中心</h2>
    <div class="tips">亲爱的 {{ vuex_userInfo.nickName }} : 您好!欢迎访问缩水网</div>
    <div class="user">
      <div class="left">
        <img v-if="vuex_userInfo.avatar" :src="$imgUrl+vuex_userInfo.avatar"
             alt="头像"
             class="avatar"/>
        <img class="avatar"
             v-else
             src="@/assets/default_avatar.png"
             alt="头像"/>

        <div>{{ vuex_userInfo.nickName }}</div>
        <div class="btn"
             @click="$router.push('/personalCenter/chongzhihetixian/suobichongzhi')">充值
        </div>
        <div>
          <span>关注:{{ vuex_userInfo.attention || 0 }}</span>
        </div>
      </div>
      <div class="right">
        <div>
          <div class="rig_left">
            <el-carousel height="150px"
                         v-if="userInfo.params && userInfo.params.advertisement.length">
              <el-carousel-item v-for="(item,index) in userInfo.params.advertisement"
                                :key="index">
                <img :src="item.link"
                     :alt="item.title">
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="rig_right"
               style="margin-left:20px;font-size: 13px;">
            网站彩市动态
            <ul style="padding-left: 15px;">
              <li v-for="(item,index) in noticeList"
                  :key="index"
                  @click="gotoArticle_details(item)"
                  style="white-space: nowrap; padding: 5px 0;">{{ item.noticeTitle }}
              </li>
            </ul>
          </div>
        </div>
        <div style="line-height:30px">
          <span style="margin-right:50px">缩币余额：<strong
              style="color:red">{{ vuex_userInfo.userAccount.virtualCoin || 0 }}</strong> 个</span>
          <span>账户余额：<strong style="color:red">{{ vuex_userInfo.userAccount.balance || 0 }}</strong> 元</span>
        </div>
        <div>彩票箴言：<span>{{ vuex_userInfo.userAccount.motto || '这个人很懒没有留下任何信息！' }}</span></div>
      </div>

    </div>

    <div class="roleList">
      <div>
        <span>审核通过:</span>
        <div>
                    <span v-for="(item,index) in reviewAbout.ytg"
                          :key="index">{{ item }}</span>
        </div>

      </div>
      <div>
        <span>审核中:</span>
        <div v-if="reviewAbout.wsh && reviewAbout.wsh.length">
                    <span v-for="(item,index) in reviewAbout.wsh"
                          :key="index">{{ item }}</span>
        </div>
        <div v-else>暂无</div>

      </div>
      <div>
        <span>审核驳回:</span>
        <div style="
					font-weight: bold;
					font-size: 14px;
					color: red;
					position: relative;
					top: 2px;
					cursor: pointer;
				"
             @click="reviewReject.show = true">查看所有审核驳回的详细信息
        </div>
      </div>
    </div>

    <div class="pindao">

      <yhzxTable
          v-for="table in tables" :key="table.ref"
          :ref="table.ref"
          :db="table"
          @getList="getList"></yhzxTable>

    </div>

    <el-dialog title="审核驳回"
               append-to-body
               :visible.sync='reviewReject.show'>
      <el-table :data="reviewReject.db"
                v-loading="tableLoading">
        <el-table-column type="index"
                         label="序号"></el-table-column>
        <el-table-column label="申请师种"
                         prop="roleNames"
                         width="120"></el-table-column>
        <el-table-column label="申请时间"
                         prop="updateTime"
                         width="170"></el-table-column>
        <el-table-column label="驳回原因"
                         prop="reason"></el-table-column>

      </el-table>

      <!-- v-if="listPagin.total > 9"  -->
      <el-pagination style="padding-top:20px;text-align:right"
                     background
                     layout="prev, pager, next"
                     @current-change="changePage"
                     :page-size="listPagin.limit"
                     :total="listPagin.total">
      </el-pagination>
    </el-dialog>

  </div>
</template>

<script>
import yhzxTable from './yhzx_table.vue'
import {getInfo, notice_list} from '@/api/home'

import {infoList} from "@/api/yhzx"

import {queryLotteryStatus} from "@/api/personalCenter"

export default {
  components: {
    yhzxTable
  },
  data() {
    return {
      tables: [
        {
          ref: 'sss',
          list: [],
          productModel: 0,
          tit: '缩水师频道',
          type: '缩水师',
          title: ['购买期数', '认购会员', '购买指标类型', '指标准确率', '价格', '下载/查阅', '购买时间']
        },
        {
          ref: 'jqs',
          list: [],
          productModel: 1,
          tit: '技巧师频道',
          type: '技巧师',
          title: ['购买期数', '认购技巧师', '认购技巧类型', '上期图表准确率', '价格', '下载/查阅', '购买时间']
        },
        {
          ref: 'rjjy',
          list: [],
          productModel: 2,
          tit: '软件交易师频道',
          type: '软件交易师',
          title: ['认购时间', '认购软件交易师', '认购软件彩种', '认购软件类型', '售后免费维护期', '价格', '备注', '操作']
        },
        {
          ref: 'tzz',
          list: [],
          productModel: 3,
          tit: '投注站帮扶中心',
          type: '投注站',
          title: ['认购投注站站号', '认购投注站地址', '认购每股价格', '认购众筹招股', '上传实战票', '兑奖情况', '备注', '操作']
        }

      ],

      // 审核驳回
      reviewReject: {
        show: false,
        db: []
      },
      listPagin: {
        page: 1,
        limit: 10,
        total: 0
      },
      tableLoading: false,

      userInfo: {},
      noticeList: [],

      //审核相关
      reviewAbout: {},
    }
  },
  watch: {
    'reviewReject.show'(val) {
      if (val) {
        this.bohuiList()
      }
    },
  },
  mounted() {

    this.getUserinfo()

    // 站内信
    notice_list().then(res => {
      this.noticeList = res.rows.slice(0, 5)
    })


    // this.getQueryLotteryStatus()
  },
  methods: {

    gotoArticle_details(item) {
      this.$vuex('vuex_articleDetails', item)
      this.$router.push({name: 'article_details'})
    },

    getUserinfo() {
      getInfo().then(res => {
        this.userInfo = res.data

        let roles = JSON.parse(JSON.stringify(res.data.user.roles)),
            removeIndex = roles.findIndex(item => item.roleKey === 'commonuser');

        if (removeIndex !== -1) {
          roles.splice(removeIndex, 1);
        }

        this.shenheList()

      })
    },

    // 审核通过/审核中
    shenheList() {
      // 获取角色列表中  审核中  和   审核驳回的数据
      infoList({
        userId: this.userInfo.user.userId,
        status: '0,1',
        pageSize: 100
      }).then(res => {
        let {rows} = res
        // console.log('ss',JSON.parse(JSON.stringify(rows)));
        this.reviewAbout = {
          // 未审核
          wsh: quchong(0),
          // wsh: rows.filter(item => item.auditStatus.value == 0),
          // 未通过
          // wtg: rows.filter(item => item.auditStatus.value == 2),
          // 已通过
          ytg: quchong(1),
        }

        function quchong(type) {
          const originalString = rows.filter(item => item.auditStatus.value == type).map(ite => ite.roleNames)
          // 按 "----" 分割字符串，去重
          const splitArray = Array.from(new Set(originalString));

          // 打印去重后的结果
          // console.log(splitArray);
          return splitArray
        }

      })
    },
    // 驳回列表
    bohuiList() {
      infoList({
        userId: this.userInfo.user.userId,
        status: '2',
        pageNum: this.listPagin.page,
        pageSize: this.listPagin.limit
      }).then(res => {
        let {rows, total} = res
        console.log('驳回列表', res);
        this.reviewReject.db = rows
        this.listPagin.total = total
        this.tableLoading = false
      })
    },
    // 分页状态变化
    changePage(e) {
      this.tableLoading = true
      this.listPagin.page = e
      this.bohuiList();
    },
    // 查询当前用户所有彩种的申请状态
    getQueryLotteryStatus() {
      queryLotteryStatus({
        userId: this.vuex_userInfo.userId
      }).then(res => {
        console.log('getQueryLotteryStatus', res);
      })
    },
    getList(lotteryType = 1, type) {
      console.log('type', type);

      const typeToUrlMap = {
        '缩水师': '/center/suoshui',
        '技巧师': '/center/excel',
        '软件交易师': '/center/software',
        '投注站': '/center/offer'
      };

      console.log('typeToUrlMap', typeToUrlMap);

      let userId = JSON.parse(localStorage.getItem('userInfo')).userId
      this.$http.post(typeToUrlMap[type], {
        lotteryType,
        userId
      }).then(res => {

        const typeToTableMap = {
          '缩水师': 'sss_table',
          '技巧师': 'jqs_table',
          '软件交易师': 'rjjy_table',
          '投注站': 'tzz_table'
        };

        const tableKey = typeToTableMap[type];
        console.log('tableKey', tableKey);
        if (tableKey) {
          this[tableKey].db = res.data;
        }

        // type == '缩水师' ? this.sss_table.db = res.data :
        //     type == '技巧师' ? this.jqs_table.db = res.data :
        //         type == '软件交易师' ? this.rjjy_table.db = res.data :
        //             type == '投注站' ? this.tzz_table.db = res.data : ''

      })
    },
  }
};
</script>

<style lang="scss" scoped>
.rig_right {
  li {
    cursor: pointer;

    &:hover {
      transition: transform 0.5s;
      transform: scale(1.1);
      font-weight: bold;
      transform-origin: left;
    }

    &:not(:hover) {
      transition: transform 0.5s;
      transform: scale(1);
      font-weight: inherit;
      transform-origin: left;
    }
  }
}

.roleList {
  margin: 10px 0;

  > div {
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    padding-bottom: 10px;

    > span {
      display: inline-block;
      width: 80px;
      text-align: right;
      position: relative;
      top: 1px;
    }

    > div {
      flex: 1;
      margin-left: 10px;

      span {
        font-size: 12px;
        display: inline-block;
        padding: 5px 10px;
        border: 1px solid rgba(0, 0, 0, 0.2);
      }

      .reason {
        font-size: 12px;
        color: red;
      }
    }
  }
}

h2 {
  margin-top: 0;
}

.tips {
  background-color: #347caf;
  color: #ffffff;
  padding: 10px;
  margin-bottom: 30px;
}

.user {
  display: flex;

  > div {
    border: 1px solid rgba(0, 0, 0, 0.2);

    &.left {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 180px;
      margin-right: 30px;
      line-height: 30px;

      img {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        margin-bottom: 20px;
        background-color: rgba(0, 0, 0, 0.1);
      }

      .btn {
        cursor: pointer;
        background-color: #347caf;
        color: #fff;
        padding: 0 10px;
        border-radius: 5px;
      }
    }

    &.right {
      flex: 1;
      padding: 10px 20px;

      > div {
        &:nth-child(1) {
          height: 150px;
          display: flex;
          justify-content: space-between;
          margin-bottom: 15px;

          > div {
            flex: 1;
          }
        }

        .rig_left {
          img {
            max-width: 100%;
          }
        }
      }
    }
  }
}
</style>